settings_module = settings_module or {}
settings_module.place_detail = (set_place_type_url, lang)->
    true
